import React, {memo, Suspense, useEffect} from 'react';
import {useSelector} from "react-redux";
import {
    getHrStageCurrent,
} from "../../selectors";
import {
    selectStagePlanData,
    selectStagePlanError,
    selectStagePlanIsLoading,
    StagePlan
} from "../../../../../components/v2/stage-plan";
import {getStagePlanData} from "../../../../../store/stagePlan/action-creators";
import {setStagePlanClear} from "../../../../../store/stagePlan/actions";
import { useAppDispatch } from '../../../../../hooks/useAppDispatch/useAppDispatch'
interface HrStagePlanProps {
    className?: string
    id: string | number
    hideHeader?: boolean
}

export const HrStagePlan: React.FC<HrStagePlanProps> = memo((props: HrStagePlanProps) => {
    const {className, id, hideHeader} = props;
    const dispatch = useAppDispatch();
    const stagePlanIsLoading = useSelector(selectStagePlanIsLoading);
    const stagePlanError = useSelector(selectStagePlanError);
    const stagePlanFiles = useSelector(selectStagePlanData);
    const stage = useSelector(getHrStageCurrent);

    useEffect(() => {
        let mounted = true
        if (stage !== undefined && id !== 'new') {
            if (mounted) {
                dispatch(getStagePlanData('hr', id));
            }
        }
        return () => {
            mounted = false
            dispatch(setStagePlanClear());
        };
    }, [stage, id, dispatch])

    return (
        <Suspense fallback={''}>
            <StagePlan
                isLoading={stagePlanIsLoading}
                items={stagePlanFiles}
                error={stagePlanError}
                className={className}
                title={'Прогноз исполнения'}
                emptyMessage={'Прогноз исполнения пуст'}
                typeItem={'hr'}
                hideHeader={hideHeader}
            />
        </Suspense>
    );
});
